/**
 * Check whether should show remove button
 * @param isEmpty availability array is empty
 */
export default function shouldShowRemove(isEmpty: boolean) {
  if (!isEmpty) {
    return true;
  }
  return false;
}
